(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
// Qty +/- buttons on cart page
document.querySelectorAll('.cart-pg-qty-btn').forEach(function(btn) {
  btn.addEventListener('click', function() {
    var idx = btn.dataset.index;
    var input = document.querySelector('.cart-pg-qty-input[data-index="' + idx + '"]');
    if (!input) return;
    var val = parseInt(input.value) || 0;
    if (btn.dataset.action === 'plus') {
      input.value = val + 1;
    } else {
      input.value = Math.max(0, val - 1);
    }
    // Auto-submit to update cart
    document.getElementById('cartUpdateBtn').click();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-faq"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  function initProductFaqs() {

    document
      .querySelectorAll('.pfaq-item')
      .forEach(function(item) {

        if (item.dataset.faqInitialized === 'true') {
          return;
        }

        item.dataset.faqInitialized = 'true';


        var icon =
          item.querySelector('.pfaq-icon');


        function updateIcon() {

          if (!icon) return;

          icon.textContent =
            item.open ? '−' : '+';

        }


        updateIcon();


        item.addEventListener(
          'toggle',
          updateIcon
        );

      });

  }


  initProductFaqs();


  document.addEventListener(
    'shopify:section:load',
    initProductFaqs
  );

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
// Auto-open FAQ item if URL has a matching hash
(function() {
  var hash = window.location.hash;
  if (!hash) return;
  var target = document.querySelector(hash);
  if (target && target.tagName === 'DETAILS') {
    target.open = true;
    setTimeout(function() {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"]) return;
  try {
    
document.querySelectorAll('.pfaq-item').forEach(function(item) {
  item.addEventListener('toggle', function() {
    var icon = item.querySelector('.pfaq-icon');
    if (icon) icon.textContent = item.open ? '−' : '+';
  });
});

  } catch(e) { console.error(e); }
})();
})();
